const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6 6.56445H18L17.5689 18.6358C17.5304 19.7119 16.6469 20.5645 15.5702 20.5645H8.42985C7.35306 20.5645 6.46955 19.7119 6.43112 18.6358L6 6.56445Z"
        stroke="#DD2C2F"
        strokeWidth="1.5"
      />
      <path
        d="M9 5.56445C9 4.45988 9.89543 3.56445 11 3.56445H13C14.1046 3.56445 15 4.45988 15 5.56445V6.56445H9V5.56445Z"
        stroke="#DD2C2F"
        strokeWidth="1.5"
      />
      <path d="M4 6.56445H20" stroke="#DD2C2F" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M9 9.56445L9.25 17.5645"
        stroke="#DD2C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 9.56445V17.5645"
        stroke="#DD2C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15 9.56445L14.75 17.5645"
        stroke="#DD2C2F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default DeleteIcon
